module.exports = __webpack_public_path__ + "img/RupiahUpIcon.c9c08ee8.svg";